import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountComponent } from './account.component';
import { UsersResolver } from './users/users.resolver';
import { UserResolver } from '../core/user/user.resolver';
import { AgentResolver } from '../core/agent/agent.resolver';
import { BillingResolver } from './billing/billing.resolver';
import { WebsiteTextingStatusResolver } from '../core/subscription/website-texting-status.resolver';
import { EnsureSubscriptionResolver } from '../core/subscription/ensure-subscription.resolver';
import { redirectToSection } from '../core/helpers/section-route';

const routes: Routes = [
  {
    path: '', component: AccountComponent,
    resolve: {
      activeBusiness: UserResolver,
      users: UsersResolver,
      agent: AgentResolver,
      subscriptionDetails: BillingResolver,
      wtStatus: WebsiteTextingStatusResolver,
      subscription: EnsureSubscriptionResolver
    },
    runGuardsAndResolvers: 'pathParamsChange'
  },
  { path: ':section', redirectTo: redirectToSection('/account') }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule {
}
